<template>
  <transition>
    <div class="nd-toast">
      <p>
        {{message}}
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'nd-toast'
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

    .nd-toast {
        max-width: 70%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        z-index: 9999;

        p {
            padding: 24px 20px 20px;
            font-size: 28px;
            border-radius: 10px;
            color: #FFFFFF;
            background: rgba(0, 0, 0, 0.7);
        }
    }
</style>